import React from "react";
import Releves from "./Releves";


const RelevesVente = () => {
    return <Releves tierLabel="Client" tiersApi="Clients" />;
};

export default RelevesVente;
